import { jsx as _jsx } from "react/jsx-runtime";
import { Loading } from '@guildeducationinc/recess';
import { ViewProgram } from '@src/components/Employee/Programs/ViewProgram';
import { ProgramContextProvider } from '@src/contexts/ProgramContextProvider';
import { usePrograms } from '@src/hooks/usePrograms';
import { getQueryParam, useLocale } from 'pe-core-frontend';
import { useParams } from 'react-router-dom';
export const Program = () => {
    const { t } = useLocale();
    const { id = '' } = useParams();
    const employeeId = getQueryParam('empId');
    const { find, loading } = usePrograms({
        employeeId: employeeId ? parseInt(employeeId, 10) : undefined,
        isCurrentUser: !employeeId,
    });
    const program = find(parseInt(id, 10));
    return (_jsx(Loading, { label: 'Program', loaded: !loading, showChildrenWhileLoading: true, overlay: true, children: (program && (_jsx(ProgramContextProvider, { program: program, children: _jsx(ViewProgram, { program: program }) }))) ||
            t('Error loading program') }));
};
